import {Component, Input} from '@angular/core';

@Component({
    selector: 'nlr-tab',
    templateUrl: './tab.component.html',
    imports: [],
    styleUrls: ['./tab.component.scss']
})
export class TabComponent {
    @Input() id: number;
    @Input() title: string = '';
    @Input() content: string = '';
    @Input() active: boolean = false;
    @Input() preventSelection?: () => boolean;
}
